import style from './Product.module.css';
import whatsapp from "../../../../assets/img/whatsapp.png";

const Product = ({ id, brand, category, description, image, price }) => {

    const formattedPrice = price.toLocaleString();

    return (
        <div className={style.div}>
            <a href={`https://api.whatsapp.com/send?phone=5492216954484&text=Buenos%20días,%20quisiera%20consultar%20por%20el%20producto%20en%20oferta%20${description}`} target="_blank" rel="noopener noreferrer">
                <div className={style.link}>
                    
                        <p className={style.title}>{category}&nbsp;{brand}</p>
                        <div className={style.imageContainer}><img src={image} alt={description} /></div>
                        <div className={style.textContainer}>
                            <p className={style.price}>${formattedPrice}</p>
                            <p>{description}</p>
                            <p className={style.price}><img src={whatsapp} alt=""/>Consultá por este producto</p>
                        </div>
                    
                </div>
            </a>
        </div>
    );
}

export default Product;
